import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../../../../services/api';
import './authPage.css';
import { authFields } from './authConfig';

const AuthPage = () => {
  // Состояние для хранения значений полей формы
  const [formData, setFormData] = useState({});
  // Состояние для ошибок
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  // Обработчик изменения значения в полях формы
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Обработчик отправки формы (только для входа)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const payload = {
        username: formData.username,
        password: formData.password,
      };

      // Отправляем запрос на вход
      await api.post('/auth/login', payload);
      const success = await login(formData.username, formData.password);
      if (success) {
        navigate('/');
      } else {
        setError('Ошибка входа');
      }
    } catch (err) {
      // Проверяем наличие ответа от сервера и выводим его сообщение
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data ||
        err.message ||
        'Произошла ошибка';
      setError(errorMessage);
      console.error("Ошибка на странице входа: ", err);
    }
  };

  // Используем поля для входа из конфигурации
  const fieldsToRender = authFields.login;

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Вход</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          {fieldsToRender.map((field) => (
            <div key={field.name} className="form-group">
              <label htmlFor={field.name}>{field.label}:</label>
              <input
                type={field.type}
                id={field.name}
                name={field.name}
                placeholder={field.placeholder}
                required={field.required}
                onChange={handleChange}
                value={formData[field.name] || ''}
              />
            </div>
          ))}
          <button type="submit">Войти</button>
        </form>
      </div>
    </div>
  );
};

export default AuthPage;
